<template>
  <div :class="`module_box ${moduleBg?'module_bg':''} ${moduleBgBlue?'module_bg_blue':''}`">
    <div class="width">
      <div class="module_title">{{moduleInfo.title}}</div>
      <div class="module_title_desc">
        <div>{{moduleInfo.desc.text1}}</div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    moduleBg: {
      type: Boolean,
      default: false,
    },
    moduleBgBlue: {
      type: Boolean,
      default: false,
    },
    moduleInfo: {
      default: {
        title: "",
        desc: {
          text1: "",
        },
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.module_box {
  &.module_bg {
    background-color: @bgColor;
  }
  &.module_bg_blue{
    background-color: @blueColor;

    .module_title,.module_title_desc,.module_item_text{
      color: @whiteColor;
    }

  }
  padding: 80px 0;

  .module_title {
    line-height: 80px;
    text-align: center;
    font-size: 32px;
    color: @blackColor;
  }

  .module_title_desc {
    text-align: center;
    color: @fontColorDesc;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 60px;
  }
}
</style>